import $ from "jquery";
import _ from "underscore";
import * as Sentry from '@sentry/browser';

export default {
    install(options) {
        Sentry.init(_.extend({
            beforeSend(event) {
                if (window.$qs && window.$qs.app) {
                    try {
                        event.tags = event.tags || {};
                        event.tags['connection.slow'] = window.$qs.app.detectSlowConnection();
                    } catch (err) {
                        console.error("Failed to detect slow connection: " + err);
                    }
                }

                return event;
            },
            ignoreErrors : [
                /Non-Error exception captured.*/,
                /Non-Error promise rejection captured.*/
            ],
            integrations: [
                Sentry.replayIntegration(),
            ]
        }, options.init));

        // configure Scope
        Sentry.configureScope(function (scope) {
            if (options.scope.user) {
                scope.setUser(options.user);
            }

            _.each(options.scope.tags, function (value, key) {
                scope.setTag(key, value);
            });
        });

        $(function () {
            $qs.logger.extend({
                info: function (message, extra) {
                    Sentry.withScope(function (scope) {
                        if (extra) {
                            if (typeof(extra) == "object") {
                                _.each(extra, function (value, key) {
                                    scope.setExtra(key, value);
                                });
                            }
                            else {
                                scope.setExtra('params', extra);
                            }
                        }

                        Sentry.captureMessage(message, 'info');
                    });
                },
                warn: function (message, extra) {
                    Sentry.withScope(function (scope) {
                        if (extra) {
                            if (typeof(extra) == "object") {
                                _.each(extra, function (value, key) {
                                    scope.setExtra(key, value);
                                });
                            }
                            else {
                                scope.setExtra('params', extra);
                            }
                        }

                        Sentry.captureMessage(message, 'warning');
                    });
                },
                error: function (message, exception, extra) {
                    Sentry.withScope(function (scope) {
                        if (extra) {
                            if (typeof(extra) == "object") {
                                _.each(extra, function (value, key) {
                                    scope.setExtra(key, value);
                                });
                            }
                            else {
                                scope.setExtra('params', extra);
                            }
                        }

                        if (exception) {
                            Sentry.captureException(exception);
                        }
                        else {
                            Sentry.captureMessage(message, 'error');
                        }
                    });
                }
            })
        });
    }
}